/**
 * PATH: packages/ui/src/kanban/card-surface/runtime/cardCapabilityContext.ts
 * FILE_ID: UI-KANBAN-CARDSURFACE-CONTEXT-001
 * PURPOSE: Hold the internal context object for the board card runtime.
 * WHY: Keep provider fast-refresh boundaries free of non-component exports.
 * FLOW: provider value → optional/required runtime hooks.
 * DEPENDENCIES: react; ../contract.ts.
 * RELATED: CardCapabilityProvider.tsx; useCardCapabilityRuntime.ts.
 */
import { createContext } from 'react'

import type { CardSurfaceRuntime } from '../contract'

export const CardCapabilityContext = createContext<CardSurfaceRuntime | null>(null)
